import logoLogin from '../../assets/logo-login.png';
import logoNav from '../../assets/logo.png';
import usersImage from '../../assets/users-img.png';
import companiesImage from '../../assets/companies-img.png';
import pharmacyImage from '../../assets/pharmacys-img.png';
import statisticsImage from '../../assets/statistics-img.png';
import ordersImage from '../../assets/orders-img.png';
import orderPreview from '../../assets/photo.png';
import orderPreview2 from '../../assets/photo2.png';
import orderPreview3 from '../../assets/photo3.png';
import uploadPlaceholder from '../../assets/upload.png';
import uploadPlaceholderLogo from '../../assets/logo-white.png';
import mobilePreview from '../../assets/mobile-preview.png';
import patientsImage from '../../assets/patient.png';

const images = {
    LOGIN_LOGO: logoLogin,
    NAV_LOGO: logoNav,
    USERS_IMAGE: usersImage,
    COMPANIES_IMAGE: companiesImage,
    PHARMACY_IMAGE: pharmacyImage,
    STATISTICS_IMAGE: statisticsImage,
    ORDERS_IMAGE: ordersImage,
    ORDER_PREVIEW: orderPreview,
    ORDER_PREVIEW2: orderPreview2,
    ORDER_PREVIEW3: orderPreview3,
    UPLOAD_PLACEHOLDER: uploadPlaceholder,
    UPLOAD_PLACEHOLDER_LOGO: uploadPlaceholderLogo,
    MOBILE_PREVIEW: mobilePreview,
    PATIENTS_IMAGE: patientsImage
};

export default images;



// WEBPACK FOOTER //
// ./src/customModules/Common/Images.js